"use client"

import type React from "react"
import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import "./Header.css"
import logo from "../../assets/logoblack.png" 

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname === path ? "active" : ""
  }

  const handleLinkClick = () => {
    setIsMenuOpen(false) // Закрыть меню
  }

  return (
    <header className={location.pathname === "/" ? "header header--overlay" : "header"}>
        <div className="header-content reveal">
          <Link to="/" className="logo" onClick={handleLinkClick}>
            <img src={logo} alt="Текс Молл" className="logo-img" />
          </Link>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <Link to="/" className={`nav-link ${isActive("/")}`} onClick={handleLinkClick}>
              Главная
            </Link>
            <Link to="/catalog" className={`nav-link ${isActive("/catalog")}`} onClick={handleLinkClick}>
              Каталог
            </Link>
            <Link to="/about" className={`nav-link ${isActive("/about")}`} onClick={handleLinkClick}>
              О нас
            </Link>
            <Link to="/contact" className={`nav-link ${isActive("/contact")}`} onClick={handleLinkClick}>
              Контакты
            </Link>
          </nav>

          <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
    </header>
  )
}

export default Header
